import {FormControl, TextField} from "@mui/material";
import React from "react";
import {DateTimePicker} from "@mui/x-date-pickers";
import moment from "moment-timezone";
import {DATE_FORMAT_IN_READABLE_FORMAT} from "../config/DateTimeConstants";

export default function DateTimeSelect({isNonEditable, label, currentDate, handleDateChanged, additionalProperties}) {
    return <>
        {
            (() => {
                if (isNonEditable) {
                    return <TextField
                      id='date-select'
                      label={label}
                      className="text-ellipsis"
                      value={currentDate ? moment(currentDate).format(DATE_FORMAT_IN_READABLE_FORMAT) : "None"}
                      variant='standard'
                      slotProps={{input: {readOnly: true}}} />;
                } else {
                    return <FormControl fullWidth>
                        <DateTimePicker
                          {...additionalProperties}
                          label={label}
                          value={currentDate}
                          onChange={newValue => handleDateChanged(newValue)}
                          ampm={false}
                          sx={{width: '94%'}}
                          renderInput={params => <TextField {...params} />}
                          disableMaskedInput={true}
                          format={DATE_FORMAT_IN_READABLE_FORMAT} />
                    </FormControl>;
                }
            })()
        }
    </>;
}
